import { v4 as uuidv4 } from 'uuid';

import { getListValue } from 'components/List/List.utils';
import { isObjEmpty } from 'helpers/helpers';

function getSearchDisplayValue(displayField: any, searchValues: any) {
  const fields = String(displayField || '').split(',');
  const values = fields
    .map((field: string) => searchValues[field.trim()])
    .filter(Boolean);
  return values.join(' | ');
}
function getValuesAccordingToType(item: any, value: any) {
  if (
    item.FIELDTYPE === 'Date' ||
    item.FIELDTYPE === 'DateTime' ||
    item.FIELDTYPE === 'Time'
  ) {
    // safari dont support '-' format
    const displayValue =
      Boolean(value) === true ? new Date(value.replace(/-/g, '/')) : undefined;
    return { fieldValue: value, displayValue };
  }
  if (item.FIELDTYPE === 'List' || item.FIELDTYPE === 'Hidden') {
    if (typeof value === 'string') {
      const fieldValue = value.split('|').shift()?.trim();
      return { fieldValue, displayValue: value };
    }
  }
  if (item.FIELDTYPE === 'Text') {
    if (item.FIELDPROPERTY !== 'Text') {
      return {
        fieldValue: value.replace('.', ','),
        displayValue: value.replace('.', ','),
      };
    }
  }
  return { fieldValue: value, displayValue: value };
}

export function createNewItem({ item, index, eventData }: any) {
  const { editData, searchData } = eventData;

  const [objectName, tableName] = item.FIELDNAME.split('.');
  if (!(editData && editData[objectName])) return item;
  const editValues = editData[objectName][index];
  if (!(editValues && editValues[tableName])) return item;

  // ------ Serch fields ------
  if (item.FIELDTYPE === 'Search') {
    if (isObjEmpty(searchData)) return item;
    if (!(objectName in searchData)) return item;
    const objectData = searchData[objectName];
    if (!(tableName in objectData)) return item;
    const searchValues = objectData[tableName][index];
    if (!searchValues) return item;
    return {
      ...item,
      FIELDVALUE: editValues[tableName],
      DISPLAYVALUE: getSearchDisplayValue(item.FIELDDISPLAY, searchValues),
    };
  }
  if (item.FIELDTYPE === 'String') {
    const { stringData } = eventData;
    if (stringData && item.FIELDEDITOR in stringData) {
      const stringListValues = stringData[item.FIELDEDITOR];
      const rawValue = editValues[tableName];
      if (stringListValues?.data && rawValue != null && rawValue !== '') {
        return {
          ...item,
          FIELDVALUE: rawValue,
          DISPLAYVALUE: getListValue(stringListValues.data, rawValue),
        };
      }
    }
  }

  // ----- else ------
  const { fieldValue, displayValue } = getValuesAccordingToType(
    item,
    editValues[tableName],
  );
  return { ...item, FIELDVALUE: fieldValue, DISPLAYVALUE: displayValue };
}

function updateLinesWithRest(newLines: any, rest: any) {
  return newLines.map((storeLine: any) => {
    for (let i = 0; i < rest.length; i++) {
      const { item, index } = rest[i];
      storeLine.item.splice(index, 0, item);
    }
    return { ...storeLine, item: storeLine.item };
  });
}
export function createNewLines(storeConfig: any, eventData: any) {
  const rest: any = [];
  const newLines: any = [];
  storeConfig.forEach((item: any, index: any) => {
    if (!item.FIELDNAME) {
      return rest.push({ item, index });
    }
    const [objectName] = item.FIELDNAME.split('.');
    const detailArray = eventData ? eventData.editData[objectName] : eventData;
    if (!detailArray) {
      return rest.push({ item, index });
    }
    if (newLines.length === 0) {
      for (let i = 0; i < detailArray.length; i++) {
        // Check if this line is a gift line (LINENUM = 9999999)
        const isGiftLine =
          detailArray[i].LINENUM === 9999999 || detailArray[i].LINENUM === '9999999';
        newLines[i] = {
          id: uuidv4(),
          item: [],
          ISGIFT: isGiftLine,
        };
      }
    }
    for (let i = 0; i < detailArray.length; i++) {
      const newItem = createNewItem({ item, index: i, eventData });
      newLines[i].item.push(newItem);
    }
  });
  return updateLinesWithRest(newLines, rest);
}
